import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CtaComponent } from '../../../components/home/cta/cta.component';
import { EmbedComponent } from '../../../components/home/embed/embed.component';
import { FeedbackComponent } from '../../../components/home/feedback/feedback.component';
import { SlickCarouselComponent } from '../../../components/home/slick-carousel/slick-carousel.component';
import { TopicSearchComponent } from '../../../components/home/topic-search/topic-search.component';
import { ImageBlockComponent } from '../../../components/home/image-block/image-block.component';
import { TextBlockComponent } from '../../../components/home/text-block/text-block.component';
import { LegacyStaffModule } from '../staff/legacy-staff.module';

import { CustomerCareComponent } from '../../../components/home/system/customer-care/customer-care.component';
import { SharedModule } from '../../../shared/shared.module';
import { ComponentsModule } from '../../../components/components.module';

@NgModule({
  imports: [CommonModule, SharedModule, LegacyStaffModule, ComponentsModule],
  declarations: [
    CtaComponent,
    EmbedComponent,
    FeedbackComponent,
    SlickCarouselComponent,
    TopicSearchComponent,
    ImageBlockComponent,
    TextBlockComponent,
    CustomerCareComponent,
  ],
  exports: [
    CtaComponent,
    EmbedComponent,
    FeedbackComponent,
    SlickCarouselComponent,
    TopicSearchComponent,
    ImageBlockComponent,
    TextBlockComponent,
    CustomerCareComponent,
  ],
})
export class HomeComponentsSharedModule {}
